module.exports = __webpack_public_path__ + "img/公司业务—招投标咨询.644e0e49.jpg";